import { useMemo } from 'react'
import { useTranslation } from 'next-i18next'

export default function useLocalePrice (price: number, currency: string) {
  const { i18n } = useTranslation()
  const _price = useMemo(() => price ?? undefined, [price])
  const currencyStyle = useMemo(
    () =>
      currency
        ? {
            style: 'currency',
            currency,
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          }
        : undefined,
    [currency]
  )

  return useMemo(
    () =>
      new Intl.NumberFormat(i18n.language, currencyStyle)
        .formatToParts(_price)
        .map((item) => (item.type === 'nan' ? '--' : item.value))
        .join(''),
    [_price, currencyStyle, i18n.language]
  )
}
